import { getCall, postCall, putCall, deleteCall } from '../../utils/apiCalls'
import {
  USER_LIST,
  DELETE_USER,
  USER_DETAILS,
  UPDATE_USER_STATE,
  UPDATE_USER_ROLES,
  CLEAR_USER_DETAILS,
} from './actionTypes';

import {
  ADD_USER,
  GET_USER_LIST,
  SEARCH_USER_BY_PHONE,
  UPDATE_USER_ACTIVE_STATUS
} from '../../config/urls';

export const getUserList = (query={}) => dispatch => {
  getCall(GET_USER_LIST, query)
    .then(res => {
      if(res.status === 200) {

        // in case of no data, avoid the dispatch and re-rendering
        if(!res.data || !res.data.length) return;

        dispatch({
          type: USER_LIST,
          payload: res.data || [],
        })
      } else {
        alert(((res.response || {}).data || {}).message || 'Error Occurred, please try later');
        return;
      }
    })
}

export const searchUser = (query={}, callback) => dispatch => {
  getCall(SEARCH_USER_BY_PHONE, query)
    .then(res => {
      if(res.status === 200) {
        dispatch({
          type: USER_DETAILS,
          payload: res.data || []
        })
      } else {
        const err = (res.response.data || {}).message || "Unable to fetch the user.";
        dispatch({
          type: USER_DETAILS,
          payload: { error: err }
        })
      }
      if(callback)
        callback();
    })
}

export const clearPrevUserDetails = () => ({
  type: CLEAR_USER_DETAILS,
})

export const addUser = (data, callback) => dispatch => {
  postCall(ADD_USER, data)
    .then(res => {
      if(res.status === 200) {
        alert('Added new user successfully.');
      } else {
        let err = (res.response.data || {}).message;
        alert(err || 'Something went wrong, please try later.');
      }
      if(callback)
        callback();
    })
}

export const updateUserState = (userId, data, callback) => dispatch => {
  const url = UPDATE_USER_ACTIVE_STATUS + userId + '/status';
  putCall(url, data)
    .then(res => {
      if(res.status === 200) {
        dispatch({
          type: UPDATE_USER_STATE,
          payload: { userId },
        })
        alert('Updated Successfully.');
      } else {
        alert(res.response.data.message || 'Something went wrong, please try later.');
      }
      if(callback)
        callback();
    })
}

export const updateUserRoles = (userId, data, callback) => dispatch => {
  const url = UPDATE_USER_ACTIVE_STATUS + userId + '/update-roles';
  putCall(url, JSON.stringify(data))
    .then(res => {
      if(res.status === 200) {
        // data = { roles: [...] }
        dispatch({
          type: UPDATE_USER_ROLES,
          payload: data
        })
        alert('Updated Successfully.');
      } else {
        alert(res.response.data.message || 'Something went wrong, please try later.');
      }
      if(callback)
        callback();
    })
}

export const deleteUser = (userId, callback) => dispatch => {
  const url = UPDATE_USER_ACTIVE_STATUS + userId;
  deleteCall(url)
    .then(res => {
      if(res.status === 200) {
        // data = { roles: [...] }
        dispatch({
          type: DELETE_USER,
          payload: { userId }
        })
        alert('Deleted Successfully.');
      } else {
        alert(res.response.data.message || 'Something went wrong, please try later.');
      }
      if(callback) callback();
    })
}
